import React, { Component, Fragment } from 'react'
import { withStyles, createStyles, WithStyles, Dialog, Theme, Button, Paper, Typography, Slide, Tabs, Tab } from '@material-ui/core';
import { connect, DispatchProp } from 'react-redux';
import { TState } from '../../RootReducer/index';
import _ from 'lodash';
import THEME from '../../Resources/Theme';

import { TDocument } from '../../Features/LTDDocuments/@types';
import PdfContent from '../PdfContent';
import { fade, lighten } from '@material-ui/core/styles/colorManipulator';
import { OApp } from '../../RootReducer/AppReducer';
import { TEditSection, EXTENDED_METADATA_IN, TLTDDocEditMode } from '../../Features/AddNewLTDDocument/@types';
import { ONewLTDDocument } from '../../Features/AddNewLTDDocument/redux-config';
import FormSection from './FormSection';
import { IS_MOBILE } from '../../App';
import { ILtdPermissions } from '../../Features/Authentication/@types';
import { TNode } from '../../Features/DocumentsTree/@types';
import LTDBreadcrumbs from '../../Components/Breadcrumbs/LTDBreadcrumbs';
import { WithTranslationProps, withTranslations } from '../../Features/Translations/withTranslations';
import { GENERAL_SAVE } from '../../Features/Translations/translationKeys.cld';



interface IProps extends WithStyles<typeof STYLES>, IStateProps, IDispatchProps, WithTranslationProps {
    formUpdates?: Record<string, any>
}

interface IDispatchProps {
    closeDialog: () => void
    // editLegalFinding: (key: string, value: any) => void
    confirmationDialog: (msg: string, onConfirm: Function, onCancel: Function) => void
    saveChanges: (docId: string, formData: any) => void
    createNewDocument: (nodeId: string, formData: any) => void
    updateDraft: (parentNodeId: string, form: any, subjectId?: string) => void
}

interface IStateProps {
    open: boolean
    isNewDocument: boolean
    section: TEditSection
    formData: Record<string, any>
    appConstants: any
    isDocumentModified: boolean
    editMode: TLTDDocEditMode
    additionalData?: any
    parentNodeId?: string
    ltdPermissions: ILtdPermissions,
    docPath?: Array<TNode>
}


interface IState {
    editSectionOpen: boolean
    activeNav: number
}



//
// CONFIG for sticky navbar on the left of the screen
//
const TABS_PARTIAL: Array<{ label: string, href: TEditSection, title: string }> = [
    { label: 'Basic info', href: 'basic-information', title: 'BASIC INFORMATION' },
    { label: 'Relations', href: 'relations', title: 'RELATIONS' },
    { label: 'Bibliography', href: 'biblography', title: 'BIBLIOGRAPHICAL INFORMATION' },
    { label: 'Quality control', href: 'quality-control', title: 'QUALITY CONTROL' },
]
const TABS_ALL: Array<{ label: string, href: TEditSection, title: string }> = [
    { label: 'Basic info', href: 'basic-information', title: 'BASIC INFORMATION' },
    { label: 'Relations', href: 'relations', title: 'RELATIONS' },
    { label: 'Judicial Documents', href: 'judicial-documents', title: 'JUDICIAL DOCUMENTS' },
    { label: 'ICC Documents', href: 'icc-documents', title: 'ICC DOCUMENTS' },
    { label: 'Bibliography', href: 'biblography', title: 'BIBLIOGRAPHICAL INFORMATION' },
    { label: 'Quality control', href: 'quality-control', title: 'QUALITY CONTROL' },
]




//
// COMPONENT for Section Label
// 
export const SectionLabel: React.FC<{ title: string }> = (props) => {
    return (
        <Typography style={{ background: THEME.Colors.Fourth, fontWeight: 500, color: 'white' }}>
            {props.title}
        </Typography>
    )
}

class NewLTDDocument extends Component<IProps, IState> {
    state: IState = {
        editSectionOpen: false,
        activeNav: 0
    }

    scrollElements: Array<number | undefined> = [];

    componentDidUpdate(prevProps) {
        if (this.props.open) {
            // if
            let sum = 90
            this.scrollElements = TABS_ALL.map(tab => {
                const el = document.getElementById(tab.href);
                if (el) {
                    const val = sum - el.getBoundingClientRect().height;
                    sum = sum - el.getBoundingClientRect().height;
                    return val;
                }
            })

            if (prevProps.section !== this.props.section) {
                setTimeout(() => {
                    navigateTo(this.props.section);
                }, 500);
                const activeNavIndex = _.findIndex(TABS_ALL, { href: this.props.section });
                if (activeNavIndex > -1) {
                    this.onNavigate(activeNavIndex);
                }
            }
        }
    }




    // Change the index for Sticky nav
    onNavigate = (index: number) => {
        this.setState({ activeNav: index });
    }


    onWheel = (e: React.WheelEvent<HTMLElement>) => {
        const { activeNav } = this.state;
        const { formData } = this.props;

        const TABS = EXTENDED_METADATA_IN.includes(_.get(formData, 'contentType')) ? TABS_ALL : TABS_PARTIAL;
        TABS.forEach((tab, i) => {
            const el = document.getElementById(tab.href);
            if (el) {
                const pos = el.getBoundingClientRect().top;
                if (pos >= 70 && pos <= 110 && activeNav !== i)
                    this.setState({ activeNav: i })
            }
        })
    }

    // Toggle Edit Sidebar
    toggleEdit = () => this.setState({ editSectionOpen: !this.state.editSectionOpen });


    render() {
        const { open, classes, formData, docPath } = this.props;
        const { editSectionOpen, activeNav } = this.state;
        const TABS = EXTENDED_METADATA_IN.includes(_.get(formData, 'contentType')) ? TABS_ALL : TABS_PARTIAL;
        const openEditBar = false;



        return (
            <Dialog
                fullWidth={IS_MOBILE}
                fullScreen={IS_MOBILE}
                open={open || false}
                PaperProps={{ className: classes.root }}
                classes={{ container: classes.dialogContainer }}
            >
                <section id="new-ltd-document" className={classes.wrapper}>
                    <div className={classes.fixedHeader} style={{ width: openEditBar ? 'calc(100% - 400px)' : '100%' }}>
                        <DialogTitle {...this.props} />
                    </div>
                    <div style={{ height: 90, width: '100%' }} />
                    <div className={classes.container} onWheel={this.onWheel}>

                        <Paper className={classes.stickyContainer}>
                            <StickyNav activeNav={activeNav} onNavigate={this.onNavigate} tabs={TABS} />
                        </Paper>
                        <div className={classes.breadCrumbsContainer}>
                            <LTDBreadcrumbs docPath={docPath || []} />
                        </div>
                        {
                            TABS.map(config => (
                                <FormSection
                                    key={config.href}
                                    sectionId={config.href}
                                    sectionTitle={config.title}
                                />
                            ))
                        }



                    </div>

                </section>
                {/* <section className={classes.editContainer} style={{ display: openEditBar ? 'flex' : 'none' }}>
                    <EditFields />
                </section> */}
            </Dialog>
        )
    }
}

//
// Utility function to navigate to scroll to a particular section
//
const navigateTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }

}






//
// STICKY NAVBAR
//
interface StickyNavProps {
    activeNav: number
    onNavigate: (index: number) => void,
    tabs: typeof TABS_ALL
}
const StickyNav: React.FC<StickyNavProps> = (props) => {


    const navigate = (section: string, index: number) => {
        navigateTo(section);
        props.onNavigate(index);
    }


    const sccDoc = /\/sccdoc.*/i.test(window.location.pathname);


    return (
        <Fragment>
            {props.tabs.map((tab, i) => (
                <Typography
                    align='left'
                    gutterBottom
                    style={{
                        cursor: 'pointer',
                        fontWeight: 500,
                        borderRight: IS_MOBILE
                            ? 'none'
                            : i === props.activeNav
                            ? `2px solid ${sccDoc ? THEME.Colors.Tertiary.main : THEME.Colors.Secondary.main}`
                            : 'none',
                        color:
                            i === props.activeNav
                                ? sccDoc
                                    ? THEME.Colors.Tertiary.main
                                    : THEME.Colors.Secondary.main
                                : THEME.Colors.Grayscale.Grey2,
                    }}
                    key={tab.href}
                    onClick={e => navigate(tab.href, i)}
                >
                    {tab.label}
                </Typography>
            ))}
        </Fragment>
    );
}







const DialogTitle: React.FC<IProps> = (props) => {
    const { classes, isNewDocument, formData, formUpdates, appConstants, isDocumentModified, parentNodeId, additionalData, editMode, getTranslation } = props;

    const typeOfDoc = _.get(_.find(appConstants['contentType'], { value: formData['contentType'] }), 'name');
    const title_edit = true ? `Edit ${typeOfDoc ? typeOfDoc : ''}` : ''
    const title_new = true ? `New ${typeOfDoc ? typeOfDoc : ''}` : ''
    const sccDoc = /\/sccdoc.*/i.test(window.location.pathname);



    const closeDialog = () => {
        if (isDocumentModified) {
            props.confirmationDialog("Exit without saving changes?", props.closeDialog, () => null);
        }
        else
            props.closeDialog();
    }



    const saveChanges = () => {
        if (editMode === 'draft') {
            if (!additionalData) return;
            props.updateDraft(_.get(additionalData, 'parentNodeId'), formUpdates, _.get(additionalData, 'subjectId'));
            return;
        }
        if (isNewDocument) {
            if (parentNodeId)
                props.createNewDocument(parentNodeId, formUpdates);

            return;
        }
        const id = _.get(formData, 'id');
        if (_.isEmpty(id))
            return;
        props.saveChanges(id, formUpdates);
    }



    return (
        <div id='home' className={`${classes.dialogTitle} ${sccDoc ? classes.sccDialogTitle : ''}`}>
            <Button onClick={closeDialog}>
                <i className='material-icons'>close</i>
            </Button>
            <Typography style={{ flex: '1 1 0' }}>{isNewDocument ? title_new : title_edit}</Typography>
            {isDocumentModified ? (
                <Button onClick={saveChanges} className={classes.saveBtn}>
                    {getTranslation(GENERAL_SAVE).toUpperCase()}
                </Button>
            ) : null}
        </div>
    );
}


const mapStateToProps = (state: TState): IStateProps => ({
    ..._.pick(state.NewLTDDocument, ['open', 'section', 'editMode', 'additionalData', 'formData', 'formUpdates', 'isNewDocument', 'isDocumentModified', 'parentNodeId', 'docPath']),
    appConstants: _.get(state.App, 'appConstants.LtdDoc'),
    ..._.pick(state.Auth, ['ltdPermissions'])
});

const mapDispatchToProps = (dispatch): IDispatchProps => ({
    createNewDocument: (nodeId: string, formData: any) => dispatch(ONewLTDDocument.createNewLTDDocument(nodeId, formData)),
    closeDialog: () => dispatch(ONewLTDDocument.closeDialog()),
    saveChanges: (docId: string, formData: any) => dispatch(ONewLTDDocument.saveChanges(docId, formData)),
    updateDraft: (parentNodeId, form, subjectId) => dispatch(ONewLTDDocument.updateLTDDraftDocument(parentNodeId, form, subjectId)),
    confirmationDialog: (msg: string, onConfirm: Function, onCancel: Function) => dispatch(OApp.showConfirmationDialog(msg, onConfirm, onCancel)),

})


const STYLES = (theme: Theme) =>
    createStyles({
        dialogContainer: {
            // zIndex: 1600
        },
        root: {
            position: 'absolute',
            display: 'flex',
            flexDirection: 'row',
            background: THEME.Colors.Grayscale.Grey5,
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            margin: 0,
            maxHeight: '100vh',
            borderRadius: 0,
            maxWidth: 'inherit',
        },
        fixedHeader: {
            position: 'fixed',
            zIndex: 1,
            boxShadow: `0px 2px 4px ${fade('#000', 0.2)}`,
        },
        dialogTitle: {
            background: THEME.Colors.Secondary.main,
            height: 45,
            display: 'flex',
            alignItems: 'center',
            '& i,  & p': {
                color: 'white',
            },
        },
        sccDialogTitle: {
            background: THEME.Colors.Tertiary.main,
        },
        tab: {
            minWidth: 0,
            margin: '0px 24px',
        },

        labelContainer: {
            color: 'white',
            padding: 0,
        },
        tabIndicator: {
            bottom: 2,
            height: 4,
            background: 'white',
        },

        findingContainer: {
            zIndex: 2,
            height: 'calc(100vh - 90px)',
            overflow: 'auto',
        },
        pdfContainer: {
            height: 'calc(100vh - 90px)',
            overflow: 'hidden',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
        },
        container: {
            position: 'relative',
        },
        stickyContainer: {
            display: 'flex',
            zIndex: 2,
            flexDirection: 'column',
            position: 'fixed',
            // height: 200,
            top: 130,
            padding: '20px 0px 20px 8px',
            borderRadius: '0px 4px 4px 0px',
            width: 140,
            [theme.breakpoints.down('sm')]: {
                top: 45,
                left: 0,
                width: '90%',
                overflow: 'scroll',
                // padding: '8px 20px',
                right: 0,
                flexDirection: 'row',
                justifyContent: 'space-evenly',
                alignItems: 'center',
                '& > p': {
                    margin: '0px 8px',
                    textAlign: 'center',
                    minWidth: 80,
                },
            },
        },
        wrapper: {
            flex: 1,
            position: 'relative',
            height: '100vh',
            overflow: 'scroll',
            // background: 'grey'
        },
        saveBtn: {
            background: THEME.Colors.Green,
            color: 'white',
            borderRadius: 0,
            width: 120,
            height: 45,
            '&:hover': {
                background: lighten(THEME.Colors.Green, 0.2),
            },
        },
        editContainer: {
            width: 400,
            overflow: 'auto',
            // background: 'white',
            right: 0,
            bottom: 0,
            top: 0,
            zIndex: 2,
            boxShadow: `-2px 0px 4px ${fade('#000', 0.23)}`,
        },
        breadCrumbsContainer: {
            width: 680,
            margin: '0 auto',
            position: 'relative',
            top: 30,
        },
    });


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(STYLES)(withTranslations(NewLTDDocument)));